'use strict';

var gqlUtils = require('@liquorice/gql-utils');
var FORMIE_CAPTCHA_FRAGMENT = require('./FORMIE_CAPTCHA_FRAGMENT.js');
var parseFormieCaptchas = require('./parseFormieCaptchas.js');

const useFormieCaptchaFragments = gqlUtils.withFragmentArray(FORMIE_CAPTCHA_FRAGMENT.FORMIE_CAPTCHA_FRAGMENT, (captchas)=>{
    var _parseFormieCaptchas_recaptchaCaptcha;
    const { name, handle, value } = (_parseFormieCaptchas_recaptchaCaptcha = parseFormieCaptchas(captchas).recaptchaCaptcha) != null ? _parseFormieCaptchas_recaptchaCaptcha : {};
    const formHasCaptchas = !!handle && !!name && !!value;
    return {
        gRecaptchaHandle: handle,
        gRecaptchaEnabled: formHasCaptchas,
        gRecaptchaName: name,
        gRecaptchaSiteKey: value
    };
});

module.exports = useFormieCaptchaFragments;
